// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2ng9l","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2Lm1q"};